import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Center,
  Heading,
  Input,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Component } from "react";
import { BeatLoader } from "react-spinners";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { setAdminlogin } from "../Services/AdminService";
import APIService from "../Services/APIService";
import { IBodyshopService } from "../UserService";
import "./../Common.css";
import "./Login.css";
import LoaderCommon from "../Loader/LoaderCommon";
import { Mixpanel } from "../Services/MixPanel";
import { LoginProps } from "../modals/PropInterface/LoginProps";
import { LoginState } from "../modals/StateInterface/LoginState";
import { CurrentUser } from "../modals/CurrentUser";
import { CommonMethodService } from "../Services/CommonMethodService";
import * as Sentry from "@sentry/react";
import { IBSAdonisService } from "../Services/IBSAdonisService";
import { User } from "../CommonProps";
import CountdownTimer from "./CountdownTimer";
import OTPInput from "./OTPInput";

export default class Login extends Component<LoginProps, LoginState> {
  private ibsService: IBodyshopService;
  private ibsAdonisService: IBSAdonisService;
  private apiService: APIService;
  private commonMethodService = new CommonMethodService();

  constructor(props: LoginProps) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      showLoginLoader: false,
      isErrorDialog: false,
      errorDialogMessage: "Oops! Job not found.",
      estimateNumber: 0,
      customer: null,
      userId: null,
      showDialogLoad: true,
      showDialogForgotPassword: false,
      showLoader: false,
      estimateId: "",
      jobNumber: 0,
      vehicleRegistration: "",
      isForgotPassword: false,
      loginMode: 'regular',
      otpUsername: "",
      responseUser: null,
      otpError: "",
      otpSuccess: "",
      isOTPLoading: false,
      otpValue: "",

    };
    this.ibsService = new IBodyshopService();
    this.apiService = new APIService();
    this.ibsAdonisService = new IBSAdonisService();
  }

  async componentDidMount() {
    this.load();
  }

  public async load() {
    const params = CommonMethodService.params(false);
    const token = params["token"]
    const estimateId = params["estimateid"]
    if (estimateId) {
      if (token){
          this.ibsService.logout();
          this.setState({ showLoader: true });
          const body = {
            token: decodeURIComponent(token)
          }
          await this.adminLogin(body);
          this.setState({ showLoader: false });
          return;
        }
      this.setState({ showLoader: true });
      await this.getEstimateData(params["estimateid"]);
      await this.getCustomerData(params["step"]);
      this.setState({ showLoader: false });
    }
  }

  public async getEstimateData(estimateNumber: string) {
    try {
      await this.ibsAdonisService
        .getEstimateDetailsByIdForLogin(estimateNumber)
        .then(async (result) => {
          if (result.ok) {
            const data = await result.json();
            this.setEstimateState(data);
          } else {
            this.setEstimateState(null);
            this.setErrorDialogMessage(
              true,
              "Something went wrong, Please reload the page or set proper estimateNumber"
            );
          }
        });
    } catch (ex) {
      this.setEstimateState(null);
      this.setErrorDialogMessage(
        true,
        "Something went wrong, Please reload the page or set proper estimateNumber"
      );
    }
  }

  public async getCustomerData(typeOfRequest: string) {
    if (
      !this.state.estimateNumber ||
      (!this.state?.customer?.email &&
      !this.state?.customer?.phone ) ||
      !this.state.estimateId
    ) {
      this.setErrorDialogMessage(true, "Invalid Data, Please try it again");
      return;
    }

    await this.apiService
      .getCustomerData({
        externalId: this.state.estimateNumber.toString(),
        name: this.state.customer?.name,
        email: this.state.customer?.email,
        phone:this.state.customer?.phone,
        typeOfRequest,
        estimateData: this.state.estimateData
      })
      .then(async (res) => {
        const result = await res.json();
        try {
          const actionLogsResponse = await this.apiService.getActionLogs(
            this.state.estimateId
          );
          if (!actionLogsResponse.ok) {
            throw new Error("Failed to fetch action logs");
          }
          const actionLogs = await actionLogsResponse.json();
          if (actionLogs?.length > 0) {
            const isUserActivated = Boolean(actionLogs[0]?.is_used);
  
            if (!isUserActivated) {
              try {
                const loginResponse = await this.apiService.login(
                  result.data.user.email || result.data.user.phone,
                  `${this.state.estimateNumber}`
                );
  
                const loginResult = await loginResponse.json();
  
                if (loginResponse.ok) {
                  this.changeLoginScreen(loginResult);
                  return;
                }
  
                // Handle error cases
                if (loginResult.code === "ETIMEDOUT") {
                  Sentry.captureException(loginResult);
                }
  
                this.setMixPanelError("Login", loginResult, loginResponse);
  
                const errorMessage =
                  loginResponse.status === 400
                    ? "Incorrect email or password."
                    : "Something went wrong, Please try again.";
  
                this.setErrorDialogMessage(true, errorMessage);
                this.props.ibsService.loggedIn = false;
              } catch (error) {
                this.handleLoginError(error);
              }
            }
          }

        } catch (error) {
          this.handleActionLogsError(error);
        }
        if (res.ok) {
          const data = result.data;
          if (!data.exist || !data.user.has_logged_in_via_link) {
            Mixpanel.identify(data.user?.id);
            Mixpanel.track("Register", {
              $email: data.user?.email,
              $name: data.user?.name,
              isActive: data?.isActive,
              $estimateId: data.user?.externalId,
              status: "Successfully Sent Request",
            });
            Mixpanel.people.set({
              $name: data.user?.name,
              $email: data.user?.email,
              $estimateId: data.user?.externalId,
            });

            this.changeLoginScreen(data);
          } else {
            if (!data.isActive) {
              this.setState({ isForgotPassword: true });
            }
          }
        } else {
          if (result.code === "ETIMEDOUT") {
            Sentry.captureException(result);
          }
          this.setMixPanelError("Register", result, res);
          this.setErrorDialogMessage(
            true,
            "Something went wrong, Please reload the page"
          );
        }
      })
      .catch((ex) => {
        Sentry.captureException(ex);
        this.setErrorDialogMessage(
          true,
          "Something went wrong, Please reload the page"
        );
        this.setMixPanelError("Register", ex);
      });
  }

  public async adminLogin(opt: { token: string; }) {
    try {
      const response = await this.apiService.adminLogin({
        token: opt.token,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Request failed");
      }

      const result = await response.json();

      if (result.message && result.stack) {
        throw new Error(result.message);
      }

        Mixpanel.identify(result.user?.id);
        Mixpanel.track("Admin Auto Login", {
          $email: result.user?.email,
          $name: result.user?.name,
          isActive: true,
          $estimateId: result.user?.external_id,
          status: "Successfully Sent Request",
        });
        Mixpanel.people.set({
          $name: result.user?.name,
          $email: result.user?.email,
          $estimateId: result.user?.external_id,
        });

        this.changeLoginScreen(result, true);
        
    } catch (ex:any) {
      Sentry.captureException(ex);
      this.props.ibsService.loggedIn = false;
      this.setErrorDialogMessage(true, ex?.message || "Something went wrong");
      this.setMixPanelError("Login", ex);
    }
  }


  async login() {
    if (this.state.userName === "" || this.state.password === "") {
      return;
    }
    this.setState({ showLoginLoader: true });
    if (
      this.state?.customer &&
      this.state?.customer?.email !== this.state?.userName
    ) {
      const urlWithoutQueryParams =
        window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, urlWithoutQueryParams);
    }
    const params = CommonMethodService.params();
    await this.apiService
      .login(this.state.userName, params["estimateid"], this.state.password)
      .then(async (res) => {
        const result = await res.json();
        if (res.ok) {
          this.changeLoginScreen(result);
        } else {
          if (result.code === "ETIMEDOUT") {
            Sentry.captureException(result);
          }
          this.setMixPanelError("Login", result, res);
          if (res.status === 400) {
            this.setErrorDialogMessage(true, "Incorrect email or password.");
          } else {
            this.setErrorDialogMessage(
              true,
              "Something went wrong, Please try again."
            );
          }

          this.props.ibsService.loggedIn = false;
        }
      })
      .catch((ex) => {
        Sentry.captureException(ex);
        this.props.ibsService.loggedIn = false;
        this.setErrorDialogMessage(
          true,
          "Something went wrong, Please try again."
        );
        this.setMixPanelError("Login", ex);
        return;
      });

    this.setState({ showLoginLoader: false });
  }

  private handleLoginError(error: any): void {
    Sentry.captureException(error);
    this.props.ibsService.loggedIn = false;
    this.setErrorDialogMessage(true, "Something went wrong, Please try again.");
    this.setMixPanelError("Login", error);
  }

  private handleActionLogsError(error: any): void {
    Sentry.captureException(error);
    this.setErrorDialogMessage(true, "Failed to fetch action logs");
    this.setMixPanelError("ActionLogs", error);
  }

  changeLoginScreen(data: CurrentUser, allowAll = false) {
    Mixpanel.identify(data.user.id);
    Mixpanel.track("Login", {
      email: data?.user?.email,
      status: "Successfully Login",
    });
    Mixpanel.people.set({
      $name: data?.user?.name,
      $email: data?.user?.email,
    });

    const isAdmin = data.user?.roles.find(
      (role: any) => role.name === "Administrator" || role.id === 6 || role.id === 12
    );
    if (allowAll || isAdmin) {
      setAdminlogin(true);
    } else {
      setAdminlogin(false);
    }
    this.props.ibsService.currentUser = data;
    this.commonMethodService.setDataIntoStorage("currentUser", data);
    this.props.ibsService.loggedIn = true;
    this.commonMethodService.removeSingleQueryParams("token")
    this.props.loginSuccess();

    this.setState({ showLoginLoader: false });
  }

  setErrorDialogMessage(status: boolean, message: string) {
    this.setState({
      isErrorDialog: status,
      errorDialogMessage: message,
    });
    setTimeout(() => {
      this.setState({ isErrorDialog: false, errorDialogMessage: "" });
    }, 3000);
  }

  setEstimateState(data: any) {
    this.setState({
      estimateNumber: data ? data.estimateNumber : null,
      customer: {
        name: data ? data.displayName : null,
        email: data ? data.emailAddress : null,
        phone: data ? data.phoneNumber : null,
      },
      userName: data ? data.emailAddress : "",
      estimateId: data ? data.estimateId : null,
      jobNumber: data ? data.jobNumber : 0,
      vehicleRegistration: data ? data.vehicleRegistration : null,
      estimateData: {
        estimateNumber: data ? data.estimateNumber : null,
        displayName: data ? data.displayName : null,
        emailAddress: data ? data.emailAddress : null,
        phoneNumber: data ? data.phoneNumber : null,
        estimateId: data ? data?.estimateId : null,
        jobNumber: data ? data?.jobNumber : null,
        vehicleRegistration: data ? data?.vehicleRegistration : null,
        createdAt: data ? data?.createdAt : null,
      }

    });
  }

  setMixPanelError(type: string, result: any, response?: any) {
    Mixpanel.track(type + " Error", {
      name: this.state.customer?.name,
      email: this.state.customer?.email,
      error: result.errors ? result.errors : result,
      status: response ? response.status : "Exception Throw",
    });
  }
  closeErrorDialog() {
    this.setState({ isErrorDialog: false });
  }

  async reSendEmail() {
    this.setState({
      showDialogLoad: true,
    });
    if (this.state.userId) {
      await this.apiService.reSendEmail(this.state.userId);
    }
    this.setState({
      showDialogLoad: false,
    });
  }

  private requestOTP = async (
    { email, phone }: { email: string | null; phone: string | null }
  ): Promise<User | null> => {
      try {
      const response = await this.apiService.requestOTP(email, phone);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Request failed");
      }

      const result = await response.json();

      if (result.message && result.stack) {
        throw new Error(result.message);
      }

      const user = result?.data?.user;
      if (user) {
        Mixpanel.identify(user?.id);
        Mixpanel.track("OTP Request", {
        username: user.name,
        estimateId: user?.external_id,
        status: "Successfully Requested",
        });
        Mixpanel.people.set({
          $name: user?.name,
          $email: user?.email,
          $phone: user?.phone,
          $estimateId: user?.external_id,
        });

        this.setState({ otp: result?.data?.otp })
        return user;
      }
      return null;
    } catch (ex:any) {
      Sentry.captureException(ex);
      this.props.ibsService.loggedIn = false;
      this.setMixPanelError("Request OTP", ex);
      throw new Error(ex.message || "Failed to send OTP");
    }
  };

  private verifyOTP = async (
    { otp, userId }: { otp: string; userId: string }
  ): Promise<CurrentUser | null> => {
      try {
      const response = await this.apiService.verifyOTP(otp, userId);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Request failed");
      }

      const result = await response.json();

      if (result.message && result.stack) {
        throw new Error(result.message);
      }

      const allowLogin = result?.auth && result?.user;
      if (allowLogin) {
        this.setState({ showLoginLoader: true });
        this.changeLoginScreen(result);
        return result;
      }
      return null;
    } catch (ex:any) {
      Sentry.captureException(ex);
      this.props.ibsService.loggedIn = false;
      this.setMixPanelError("Request OTP", ex);
      throw new Error(ex.message || "Failed to verify OTP");
    }
  };

  private switchToOTPMode = () => {
    this.setState({
      loginMode: 'otp-request',
      otpError: "",
      otpSuccess: "",
      responseUser: null,
      otp: null
    });
  };

  private switchToRegularMode = () => {
    this.setState({
      loginMode: 'regular',
      otpError: "",
      otpSuccess: "",
      otpValue: "",
      responseUser: null,
      otp: null
    });
  };

  private handleOTPRequest = async () => {
      const { otpUsername } = this.state;
      
      if (!otpUsername.trim()) {
        this.setState({ otpError: "Please enter your email or phone number" });
        return;
      }
  
      this.setState({ isOTPLoading: true, otpError: "", otpSuccess: "" });
  
      let email: string | null = null;
      let phone: string | null = null;
      try {
        if (this.commonMethodService.isValidEmail(otpUsername)) {
          email = otpUsername
        } else if (this.commonMethodService.isValidPhone(otpUsername)) {
          phone = otpUsername
        } else {
          this.setState({ 
            otpError: "Please enter a valid email address or phone number",
            isOTPLoading: false 
          });
          return;
        }
        const response : User | null = await this.requestOTP({email: email, phone: phone});
        if(response){
          this.setState({ 
              responseUser: response,
              otpSuccess: "OTP sent successfully!",
              isOTPLoading: false,
              loginMode: 'otp-verify',
            });
          setTimeout(() => {
            this.setState({ otpSuccess: "" });
          }, 3000);
        }
  
      } catch (error: any) {
        this.setState({ 
          otpError: error.message || "Failed to send OTP. Please try again.",
          isOTPLoading: false
        });
        setTimeout(() => {
          this.setState({ otpError: "" });
        }, 3000);
      }
    };


  private handleOTPVerify = async () => {
    const { otpValue, responseUser } = this.state;

    if (!otpValue.trim()) {
      this.setState({ otpError: "Please enter the provided otp." });
      return;
    }

    this.setState({ isOTPLoading: true, otpError: "", otpSuccess: "" });

    try {
      if (this.commonMethodService.isValidOTP(otpValue) && responseUser?.id) {
        await this.verifyOTP({ otp: otpValue, userId: responseUser.id });
      } else {
        this.setState({
          otpError: "Please enter a valid email address or phone number",
          isOTPLoading: false
        });
        return;
      }
    } catch (error: any) {
      this.setState({
        otpError: error.message || "Failed to verify OTP. Please try again.",
        isOTPLoading: false
      });
      setTimeout(() => {
        this.setState({ otpError: "" });
      }, 3000);
    }
  };

  private handleOTPExpired = () => {
    this.setState({
      otpError: "OTP has expired. Please request a new one.",
      responseUser: null
    });
  };

  handleOTPChange = (otp: string) => {
    this.setState({ otpValue: otp });
  };

  render() {
    const { loginMode, isOTPLoading, otpSuccess, otpUsername, otpError, otpValue, otp } = this.state;
    return (
      <Center className="defaultBG">
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={""} />
        ) : undefined}
        {this.state.showDialogForgotPassword && (
          <ForgotPassword
            closeModal={() =>
              this.setState({ showDialogForgotPassword: false })
            }
          />
        )}

          <Box
            maxW={["sm", null, "4xl"]}
            p={12}
            bg="white"
            boxShadow="lg"
            m="auto"
            borderRadius="md"
          >
            <div className="row">
              <div>
                <Heading>Customer Portal</Heading>
                <Heading fontSize={"md"} className="loginDetail">
                  Stay on top of your repairs
                </Heading>
              </div>
              <Box mt={8}>

                  {loginMode === 'otp-request' && (
                    <VStack spacing={4} align="stretch">
                      <Text fontSize="sm" color="gray.600">
                        Enter your email address or phone number to receive an OTP
                      </Text>

                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          this.handleOTPRequest();
                        }}
                      >
                        <Input
                          variant="filled"
                          placeholder="Email or Phone Number"
                          value={otpUsername}
                          onChange={(e) => this.setState({ otpUsername: e.target.value, userName: e.target.value })}
                          isDisabled={isOTPLoading}
                        />

                        {otpError && (
                          <Alert status="error" mt={2}>
                            <AlertIcon />
                            <AlertDescription>{otpError}</AlertDescription>
                          </Alert>
                        )}

                        {otpSuccess && (
                          <Alert status="success" mt={2}>
                            <AlertIcon />
                            <AlertDescription>{otpSuccess}</AlertDescription>
                          </Alert>
                        )}

                        <div className="logInBtnParent">
                          <Button
                            isLoading={isOTPLoading}
                            colorScheme="blue"
                            spinner={<BeatLoader size={8} color="white" />}
                            size="lg"
                            w={"100%"}
                            onClick={this.handleOTPRequest}
                            type="submit"
                            isDisabled={!otpUsername.trim()}
                          >
                            Send OTP
                          </Button>
                        </div>
                      </form>

                      <Box width={"100%"} marginY={"6px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                        <Text fontSize={"medium"} fontWeight={"medium"} color={"gray.500"} paddingX={"3px"}>OR</Text>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                      </Box>

                      <Button
                        colorScheme="blue"
                        variant="outline"
                        size="lg"
                        w={"100%"}
                        onClick={() => this.switchToRegularMode()}
                        type="button"
                      >
                        Log In Via Password
                      </Button>
                    </VStack>
                  )}

                  {loginMode === 'otp-verify' && (
                    <VStack spacing={4} align="stretch">
                      <Text fontSize="sm" color="gray.600">
                        Enter the OTP sent to {otpUsername}
                      </Text>

                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          this.handleOTPVerify();
                        }}
                      >
                        <OTPInput onOTPChange={this.handleOTPChange} isDisabled={isOTPLoading}/>

                        {otp?.expiresAt && (
                          <CountdownTimer
                            expiresAt={otp?.expiresAt}
                            createdAt={otp?.createdAt}
                            onExpired={this.handleOTPExpired}
                            onResend={this.handleOTPRequest}
                            warningThreshold={1}
                          />
                        )}

                        {otpError && (
                          <Alert status="error" mt={2}>
                            <AlertIcon />
                            <AlertDescription>{otpError}</AlertDescription>
                          </Alert>
                        )}

                        {otpSuccess && (
                          <Alert status="success" mt={2}>
                            <AlertIcon />
                            <AlertDescription>{otpSuccess}</AlertDescription>
                          </Alert>
                        )}

                        <div className="logInBtnParent">
                          <Button
                            isLoading={isOTPLoading}
                            colorScheme="blue"
                            spinner={<BeatLoader size={8} color="white" />}
                            size="lg"
                            w={"100%"}
                            onClick={this.handleOTPVerify}
                            type="submit"
                            isDisabled={!otpValue.trim()}
                          >
                            Verify OTP
                          </Button>
                        </div>
                      </form>

                      <Box width={"100%"} marginY={"6px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                        <Text fontSize={"medium"} fontWeight={"medium"} color={"gray.500"} paddingX={"3px"}>OR</Text>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                      </Box>

                      <Button
                        colorScheme="blue"
                        variant="outline"
                        size="lg"
                        w={"100%"}
                        onClick={() => this.switchToRegularMode()}
                        type="button"
                      >
                        Log In Via Password
                      </Button>
                    </VStack>
                  )}

                  {loginMode === 'regular' && (
                    <>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          this.login();
                        }}
                      >
                        <Input
                          variant="filled"
                          type="text"
                          placeholder="Email or Phone Number"
                          name="Username"
                          value={this.state.userName}
                          onChange={(e) => {
                            this.setState({ userName: e.currentTarget.value, otpUsername: e.currentTarget.value });
                          }}
                        />
                        <Input
                          mt={2}
                          variant="filled"
                          placeholder="Password"
                          type="password"
                          name="jobid"
                          value={this.state.password}
                          onChange={(e) => {
                            this.setState({ password: e.currentTarget.value });
                          }}
                        />
                        {this.state.isErrorDialog && (
                          <Alert status="error" mt={2}>
                            <AlertIcon />
                            <AlertDescription>{this.state.errorDialogMessage}</AlertDescription>
                          </Alert>
                        )}
                        <div className="logInBtnParent">
                          <Button
                            isLoading={this.state.showLoginLoader}
                            colorScheme="blue"
                            spinner={<BeatLoader size={8} color="white" />}
                            size="lg"
                            w={"100%"}
                            onClick={() => this.login()}
                            type="submit"
                          >
                            Log In
                          </Button>
                        </div>
                      </form>

                      <Box width={"100%"} marginY={"10px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                        <Text fontSize={"medium"} fontWeight={"medium"} color={"gray.500"} paddingX={"3px"}>OR</Text>
                        <Box className=" rounded-full " bgColor={"gray.300"} width={"40%"} height={"1px"}></Box>
                      </Box>

                      <Button
                        colorScheme="blue"
                        variant="outline"
                        size="lg"
                        w={"100%"}
                        onClick={() => this.switchToOTPMode()}
                        type="button"
                      >
                        Log In Via OTP
                      </Button>
                    </>
                  )}

                  <Box mt={12} w="100%">
                    <Link
                      style={{ textDecoration: "underline" }}
                      onClick={() =>
                        this.setState({ showDialogForgotPassword: true })
                      }
                    >
                      Forgot your password
                    </Link>
                    <Box>
                      <Text fontSize={"medium"} fontWeight={"medium"}>
                        Having trouble signing in?
                      </Text>
                      <Text fontSize={"medium"} fontWeight={"medium"}>
                        Contact customer support at{" "}
                        {
                          <Link
                            style={{ textDecoration: "underline" }}
                            href="mailto:hello@flowautobody.com.au"
                          >
                            hello@flowautobody.com.au
                          </Link>
                        }
                      </Text>
                    </Box>
                  </Box>
                {/* </form> */}
              </Box>
            </div>
          </Box>
        
      </Center>
    );
  }
}
